import { useEffect } from "react";
import { useProfile } from '../../modules';
import i18n from "../../i18n";


declare global {
  interface Window {
    onSIApiReady?: () => void;
    SI_API?: {
      showPopup: () => void;
      setChatInfo: (
        name: string,
        email: string,
        phone: string,
        department: string
      ) => void;
      // Add other SI_API methods here if needed
    };
  }
}

const SocialIntentsChat: React.FC = () => {
  const { user } = useProfile();

  const t = i18n.t;
  useEffect(() => {
    if (user) {
      // Define the callback globally
      window.onSIApiReady = () => {
        window.SI_API?.setChatInfo(
          (user.firstName ?? '') + ' ' + (user.lastName ?? ''),
          user.email ?? '',
          user.phoneNumber ?? '',
          ''
        );
      }
    };

    return () => {
      delete window.onSIApiReady;
    };
  }, [user]);

  if (!user) return;

  return (
    <>
      <script
        async
        src={`https://www.socialintents.com/api/chat/socialintents.1.4.js#${t("chat_id")}`}
      />

      <style>
        {`
          .silc-btn-button { 
            background-image: url("${t("chat_img_url")}") !important;
          }
        `}
      </style>
    </>
  );
};

export default SocialIntentsChat;